// Page loads
//   → initAjaxinate()
//   → runAjaxinateEngine() reads next page URL from #AjaxinateTargetLink
//   → Shows one-time Load more button (scroll gated)
//   → initPaginationIndicator() adds separate scroll listener for bar/arrows
// User clicks Load more
//   → loadPage() fetches next page, unlocks infinite scroll, hides button
// User scrolls near collection/search results bottom
//   → loadPage() fetches next page (loader shown)
//   → Products appended with data-page-index from ?page= param
//   → Pagination markup replaced; engine re-initialized for next URL
//   → Synthetic scroll event refreshes active page indicator
// User applies a filter (or Theme Editor section reload)
//   → facets.js replaces #ProductGridContainer HTML (or shopify:section:load)
//   → onProductGridUpdated()
//   → Scroll lock reset, Load more shown again, engine recreated
// Last page / end of results
//   → No #AjaxinateTargetLink, duplicate products, or stale next URL
//   → Scroll listener removed, pagination cleared

function getGridItemProductLink(li) {
  var productLink = li.querySelector('a.full-unstyled-link[href*="/products/"]');
  if (productLink) return productLink.getAttribute('href');

  var anyProductLink = li.querySelector('a[href*="/products/"]');
  if (anyProductLink) return anyProductLink.getAttribute('href');

  var dataUrl = li.querySelector('[data-product-url]');
  if (dataUrl) return dataUrl.getAttribute('data-product-url');

  return null;
}

function getGridItemLinks(container) {
  return Array.from(container.querySelectorAll(':scope > li'))
    .map(getGridItemProductLink)
    .filter(Boolean);
}

function CustomAjaxinate(settings) {
  var defaults = { container: '#product-grid', pagination: '#AjaxinatePagination', offset: 300 };
  this.settings = Object.assign({}, defaults, settings);
  this.container = document.querySelector(this.settings.container);
  this.pagination = document.querySelector(this.settings.pagination);
  this.requestPending = false;
  this.scrollEvent = null;
  this.loadMoreHandler = null;

  if (this.container && this.pagination) {
    this.initialize();
  }
}

CustomAjaxinate.prototype.destroy = function () {
  if (this.scrollEvent) {
    window.removeEventListener('scroll', this.scrollEvent);
    this.scrollEvent = null;
  }

  this.unbindLoadMore();
};

CustomAjaxinate.prototype.getLoadMoreButton = function () {
  return this.pagination ? this.pagination.querySelector('[data-ajaxinate-load-more]') : null;
};

CustomAjaxinate.prototype.unbindLoadMore = function () {
  var button = this.getLoadMoreButton();
  if (button && this.loadMoreHandler) {
    button.removeEventListener('click', this.loadMoreHandler);
  }
  this.loadMoreHandler = null;
};

CustomAjaxinate.prototype.hideLoadMore = function () {
  var button = this.getLoadMoreButton();
  if (!button) return;
  button.hidden = true;
};

CustomAjaxinate.prototype.showLoadMore = function () {
  var button = this.getLoadMoreButton();
  if (!button) return;
  button.hidden = false;
  button.disabled = false;
};

CustomAjaxinate.prototype.getScrollElement = function () {
  return this.container.closest('.collection, .template-search__results') || this.container;
};

CustomAjaxinate.prototype.setLoaderVisible = function (visible) {
  if (!this.pagination) return;
  var loader = this.pagination.querySelector('[data-ajaxinate-loader]');
  if (!loader) return;
  loader.classList.toggle('hide-loader', !visible);
};

CustomAjaxinate.prototype.finishLoading = function () {
  this.setLoaderVisible(false);
  this.requestPending = false;

  var button = this.getLoadMoreButton();
  if (button && !ajaxinateScrollUnlocked) {
    button.disabled = false;
  }
};

CustomAjaxinate.prototype.initialize = function () {
  this.unbindLoadMore();
  this.extendedPagination = this.pagination.querySelector('#AjaxinateTargetLink');

  if (!this.extendedPagination) {
    this.hideLoadMore();
    return;
  }

  this.nextPageUrl = this.extendedPagination.href;

  if (ajaxinateScrollUnlocked) {
    this.hideLoadMore();
    this.bindScroll();
    return;
  }

  this.showLoadMore();
  this.bindLoadMore();
};

CustomAjaxinate.prototype.bindLoadMore = function () {
  var self = this;
  var button = this.getLoadMoreButton();
  if (!button) return;

  this.loadMoreHandler = function () {
    if (self.requestPending || !self.nextPageUrl) return;

    button.disabled = true;
    self.requestPending = true;
    self.loadPage({ unlockScroll: true });
  };

  button.addEventListener('click', this.loadMoreHandler);
};

CustomAjaxinate.prototype.bindScroll = function () {
  var self = this;

  if (this.scrollEvent) {
    window.removeEventListener('scroll', this.scrollEvent);
  }

  this.scrollEvent = function () {
    if (self.requestPending || !ajaxinateScrollUnlocked) return;

    var rect = self.getScrollElement().getBoundingClientRect();
    var nearContainerBottom = rect.bottom <= window.innerHeight + self.settings.offset;

    if (nearContainerBottom) {
      if (!self.nextPageUrl) {
        self.destroy();
        return;
      }
      self.requestPending = true;
      self.loadPage();
    }
  };

  window.addEventListener('scroll', this.scrollEvent);
};

CustomAjaxinate.prototype.loadPage = function (options) {
  var xhr = new XMLHttpRequest();
  var self = this;
  var unlockScroll = options && options.unlockScroll;

  xhr.open('GET', this.nextPageUrl);
  xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  xhr.onreadystatechange = function () {
    if (xhr.readyState !== 4) return;

    if (xhr.status !== 200) {
      self.finishLoading();
      return;
    }

    if (unlockScroll) {
      ajaxinateScrollUnlocked = true;
    }

    var doc = new DOMParser().parseFromString(xhr.responseText, 'text/html');
    var incomingContainer = doc.querySelector(self.settings.container);
    var incomingPagination = doc.querySelector(self.settings.pagination);
    var existingLinks = getGridItemLinks(self.container);

    if (incomingContainer && incomingContainer.innerHTML.trim() !== '') {
      var parserDiv = document.createElement('div');
      parserDiv.innerHTML = incomingContainer.innerHTML;
      var incomingItems = parserDiv.querySelectorAll(':scope > li');
      var hasDuplicates = false;

      if (incomingItems.length > 0) {
        var firstIncomingHref = getGridItemProductLink(incomingItems[0]);
        if (firstIncomingHref && existingLinks.includes(firstIncomingHref)) {
          hasDuplicates = true;
        }
      }

      if (hasDuplicates) {
        self.destroy();
        self.pagination.innerHTML = '';
        self.finishLoading();
        return;
      }

      var urlObj = new URL(self.nextPageUrl, window.location.origin);
      var pageNum = urlObj.searchParams.get('page') || '1';
      Array.from(incomingContainer.children).forEach(function (child) {
        child.setAttribute('data-page-index', pageNum);
      });

      self.container.insertAdjacentHTML('beforeend', incomingContainer.innerHTML);
    }

    var incomingLink = incomingPagination ? incomingPagination.querySelector('#AjaxinateTargetLink') : null;

    if (!incomingPagination || !incomingLink || incomingLink.href === self.nextPageUrl) {
      self.destroy();
      self.pagination.innerHTML = '';
      self.finishLoading();
      window.dispatchEvent(new Event('scroll'));
      return;
    }

    self.pagination.innerHTML = incomingPagination.innerHTML;
    self.finishLoading();
    self.initialize();
    window.dispatchEvent(new Event('scroll'));
  };
  xhr.onerror = function () {
    self.finishLoading();
  };
  self.setLoaderVisible(true);
  xhr.send();
};

var ajaxinateInstance = null;
var ajaxinateScrollUnlocked = false;
var paginationIndicatorInitialized = false;

window.runAjaxinateEngine = function () {
  var grid = document.getElementById('product-grid');
  var pagination = document.getElementById('AjaxinatePagination');
  if (!grid || !pagination) return;

  if (ajaxinateInstance) {
    ajaxinateInstance.destroy();
    ajaxinateInstance = null;
  }

  ajaxinateInstance = new CustomAjaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    offset: 300,
  });
};

window.onProductGridUpdated = function () {
  ajaxinateScrollUnlocked = false;
  document.querySelectorAll('#product-grid > li').forEach(function (el) {
    el.setAttribute('data-page-index', '1');
  });
  window.runAjaxinateEngine();
  updateActivePageIndicator();
};

function getPaginationWrapper() {
  var grid = document.getElementById('product-grid');
  if (!grid) return null;

  var scope = grid.closest('.collection, .template-search__results');
  if (!scope) return null;

  return scope.querySelector('.pagination-wrapper');
}

function getPaginationPageItems() {
  var wrapper = getPaginationWrapper();
  if (!wrapper) return [];

  var list = wrapper.querySelector('.pagination__list');
  if (!list) return [];

  return Array.from(list.querySelectorAll('.pagination__item')).filter(function (item) {
    return /^\d+$/.test(item.textContent.trim());
  });
}

function updatePaginationArrows(currentPage, totalPages) {
  var wrapper = getPaginationWrapper();
  if (!wrapper) return;

  var currentPageNum = parseInt(currentPage, 10);
  var totalPagesNum = parseInt(totalPages, 10) || parseInt(wrapper.dataset.totalPages, 10);
  if (!totalPagesNum) return;

  wrapper.querySelectorAll('[data-pagination-arrow]').forEach(function (arrow) {
    var direction = arrow.getAttribute('data-pagination-arrow');
    var isDisabled =
      direction === 'previous' ? currentPageNum <= 1 : currentPageNum >= totalPagesNum;

    arrow.classList.toggle('pagination__item--disabled', isDisabled);

    if (isDisabled) {
      arrow.setAttribute('aria-disabled', 'true');
      arrow.setAttribute('tabindex', '-1');
      arrow.setAttribute('href', '#');
    } else {
      arrow.removeAttribute('aria-disabled');
      arrow.removeAttribute('tabindex');

      var url = new URL(window.location.href);
      url.searchParams.set('page', direction === 'previous' ? currentPageNum - 1 : currentPageNum + 1);
      arrow.setAttribute('href', url.pathname + url.search);
    }
  });
}

function updateActivePageIndicator() {
  var items = document.querySelectorAll('#product-grid > li[data-page-index]');
  if (items.length === 0) return;

  var currentActivePage = '1';
  var scrollPosition = window.scrollY || window.pageYOffset;
  var windowHeightHalf = window.innerHeight / 2;

  for (var i = 0; i < items.length; i++) {
    var elementTop = items[i].getBoundingClientRect().top + scrollPosition;
    if (scrollPosition + windowHeightHalf >= elementTop) {
      currentActivePage = items[i].getAttribute('data-page-index');
    }
  }

  var pagerItems = getPaginationPageItems();
  var wrapper = getPaginationWrapper();
  var totalPages = wrapper ? wrapper.dataset.totalPages : null;

  pagerItems.forEach(function (item) {
    var linkText = item.textContent.trim();
    var isActive = linkText === String(currentActivePage);

    item.classList.remove('pagination__item--current', 'light');
    item.removeAttribute('aria-current');

    if (isActive) {
      item.classList.add('pagination__item--current', 'light');
      item.setAttribute('aria-current', 'page');
    }
  });

  if (totalPages) {
    updatePaginationArrows(currentActivePage, totalPages);
  }
}

function initPaginationIndicator() {
  if (paginationIndicatorInitialized) return;
  paginationIndicatorInitialized = true;

  window.addEventListener('scroll', updateActivePageIndicator);
  setTimeout(updateActivePageIndicator, 500);
}

function initAjaxinate() {
  window.runAjaxinateEngine();
  initPaginationIndicator();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAjaxinate);
} else {
  initAjaxinate();
}

document.addEventListener('shopify:section:load', function (event) {
  if (event.target.querySelector('#product-grid')) {
    setTimeout(window.onProductGridUpdated, 50);
  }
});
